import type { JSX } from 'react'
export default function Watermark(): JSX.Element {
    const url = new URL(window.location.href)
    const tebutoLink = `${process.env.NEXT_PUBLIC_LANDING_BASE_URL}/?utm_source=${url.origin}&creative=booking-widget-banner`
    return (
        <a
            href={tebutoLink}
            title="Tebuto"
            target="_blank"
            className="widget-watermark absolute rotate-45 py-0.5 text-[10px] z-10"
            rel="noreferrer"
        >
            <div className="flex items-center gap-0.5 justify-center whitespace-nowrap">
                <span>Powered by</span>
                <span className="font-semibold">Tebuto</span>
            </div>
        </a>
    )
}
